import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import styles from "./SearchResult2.module.css";
import { getSpecsheetNavigationLabel, getSpecsheetNavigationLink } from "../../helpers/specsheetNavigation";

// Here we create a component for 1 search result so we can map over this later
const SearchResult2 = ({ id, active, specsheet }) => {
  const linkLabel = getSpecsheetNavigationLabel(specsheet);
  const linkURL = getSpecsheetNavigationLink(specsheet);
  const [titleSpecsheetURL, setTitleSpecsheetUrl] = useState("");

  // Here we set the name of the specsheet to be displayed in the url
  useEffect(() => {
    setTitleSpecsheetUrl(linkURL);
  }, [linkURL]);

  return (
    <div className={styles["search-result-container"]}>
      <NavLink
        to={`/specsheet/${active}/${specsheet.dsVersion}/${id}/${titleSpecsheetURL}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {linkLabel}
        <span className={styles["ds-version"]}>{" (DS" + specsheet.dsVersion + ")"}</span>
      </NavLink>
    </div>
  );
};

export default SearchResult2;
